/**
 * Classe com funções genéricas para as grids do route monitoring
 * @author: adalto.junior
 * Date: 10/10/13
 * Time: 16:40
 */
import { DefaultRequest } from 'scripts/api';

Greenmile.RouteSummary = Greenmile.RouteSummary || {};
Greenmile.RouteSummary.Grid = Greenmile.RouteSummary.Grid || {};

Greenmile.RouteSummary.Grid = function () {

    this.entity = null;
    this.lastScrollTopValue = 0;

    this.setEntity = function (entity) {

        if (entity) {
            this.entity = entity;
        }

    };

    this.containerGrid = "#RouteSummary #gridContainer";
    this.gridActionsSelector = "#RouteSummary .gridActions";

    this.getInstanceOfMenu = function () {
        return null;
    };

    this.clearAutoRefreshInterval = function () {
      ['RouteSummaryRoutes', 'RouteSummaryStops', 'RouteSummaryOrders'].forEach((entity) => {
        const autoRefresh = App.Forms[entity].autoRefresh;
        if (autoRefresh && autoRefresh.intervalId) {
          autoRefresh.clearIntervalToUpdate();
        }
      });
    };

    this.getColumns = function (callback) {
      var error = null,
        route = null;

      try {
        if (!App.Forms[this.entity].layout) {
          App.Forms[this.entity].layout = {};
        }

        if (!App.Forms[this.entity].layout.index) {
          route = new App.Routers[this.entity]();
          route.getFieldsToGridLayout(callback);
        } else {
          callback();
        }

      } catch (e) {
        error = new Monet.Exception.ReturnError(this,
          'Error on get  columns to ' + this.entity + ' on route monitoring.', e);
        error.console();
      }

    };

    this.beforeFilter = () => {
      const filterBuilder = App.Forms[this.entity].filterBuilder

      const baseHash = window.location.href.replace('/#', '');
      const routeKey = new URL(baseHash).searchParams.get('routeKey');
      const date = new URL(baseHash).searchParams.get('date');
      const routeFilter = routeKey ? { 'route.key': { value: routeKey } } : null;
      const dateFilter = date ? { 'route.date': { value: date } } : null;

      const defaultFilters = {
        ...routeFilter,
        ...dateFilter
      };

      if(routeKey && date) {
        filterBuilder.clearFilter();
        filterBuilder.setDefaultFilters(defaultFilters);
        filterBuilder.setSelectedFilters(defaultFilters);
        filterBuilder.addDefaultFilters();
        filterBuilder.renderSelectedFields();

        window.location.replace(window.location.href.replace(/\?.*/g, ''));
      }
    };

    this.show = function () {

        var error             = null,
            router            = null,
            dataView          = null,
            grid              = null,
            menu              = null,
            customizeColumns  = null,
            exportFormats     = null,
            element           = null,
            saveGridLayout    = null,
            indexColumnFrozen = -1,
            filterBuilder     = null,
            controlUpdate     = null,
            options           = {
                entity: this.entity,
                columnCheckBox: {
                    show: false
                },
                selectorToGridActions: this.gridActionsSelector,
                entityToActionGrid: this.entityToActionGrid,
                gridContainner: this.containerGrid,
                columnEdit: {
                    show: false
                },
                headerMenu: {
                    headerMenuEventClass: Monet.Grid.ActionsModules.MenuShowTotals
                },
                multiColumnSort: true,
                rowHeight: 50
            },
            optionsMenu       = {
                targetEl: "#RouteSummary #allContent #grid",
                description: 'description',
                addListenerToParent: false
            },
            enabledMenus      = null,
            callbackAfterOpenSidebar,
            defaultFilters;

        try {
            this.clearAutoRefreshInterval();
            router = new App.Routers[this.entity]();
            filterBuilder = new Monet.UI.FilterBuilder();
            filterBuilder.setFieldsOverride({
              RATING: 'INTEGER',
              TEXT_AREA: 'TEXT'
            });
            controlUpdate = new Monet.Grid.ControlUpdate();

            const fieldsToHideOnTable = [
              'primaryAssignments.driver',
              'primaryAssignments.driver.key',
              'secondaryAssignments.driver',
              'secondaryAssignments.driver.key',
              'routeView.primaryAssignments.driver',
              'routeView.primaryAssignments.driver.key',
              'routeView.primaryDriver.key',
              'routeView.secondaryAssignments.driver',
              'routeView.secondaryAssignments.driver.key',
              'routeView.primaryDriver.name'
            ];

            const executeFilter = () => {
              if (App.Forms.RouteSummaryRoutes && App.Forms.RouteSummaryRoutes.searchInProgress) {
                return;
              }

              if(grid.getActiveCell()) {
                  this.handlerActiveRowSelected(null, grid);
              }

              Monet.Grid.Utils.clearPagination(this.entity);

              this.beforeFilter();

              router.updateGrid(
                router.getFilter(),
                Monet.Grid.addDataToGrid,
                true
              );

              if (this.entity === 'RouteSummaryOrders') {
                App.Forms.RouteSummaryLineItems.ordersIds = null;
                if (App.Forms.RouteSummaryLineItems.table) {
                  App.Forms.RouteSummaryOrders.table.setSelectedRows([]);
                  App.Objects.RouteSummaryLineItems.updateGrid(App.Objects.RouteSummaryLineItems.getFilter(), null, null);
                }
              }

              if (router.updateSideBar) {
                router.updateSideBar();
              }

              Greenmile.RouteSummary.SideBar.clearStockSummaryInterval();
            };

            var afterSaveListCallback = function (context) {

                return function () {

                    Monet.Grid.Utils.clearPagination(context.entity);
                    App.Forms[context.entity].layout = {};

                    if (context.entity !== 'RouteSummaryLineItems') {

                        var filterBuilder = App.Forms[context.entity].filterBuilder;
                        filterBuilder.updateValuesSelectedFilters();
                        filterBuilder.saveState();

                    }

                    context.show();

                };

            }(this);

            const removeMenu = function (context) {
              return function (_, args) {
                const ROW_HEIGHT = 50;
                const scrollTop = args?.scrollTop;

                if (Math.abs(context.lastScrollTopValue - scrollTop) < ROW_HEIGHT) {
                  return;
                }

                const menu = document.querySelector('#RouteSummary .MonetUIFloatMenu');

                if (menu) {
                  const max = menu.childNodes.length;
                  let canDelete = true;

                  for (let cn = 0; cn < max; cn++) {
                    if (menu.childNodes[cn].className && menu.childNodes[cn].className === 'floatMenuContent') {
                      canDelete = false;
                    }
                  }

                  if (canDelete) {
                    const parent = menu.parentNode;
                    parent.removeChild(menu);
                  }
                }

                context.lastScrollTopValue = scrollTop ?? 0;
              };
            }(this);

            const getStopListFilterPreferences = function () {
              const userId = Monet.Session.User.id;
              const filters = JSON.parse(Monet.Session.sessionStorage.getItem("filters"));
              const routeSummaryStopsFilters = filters[userId].RouteSummaryStops;

              return routeSummaryStopsFilters;
            }

            controlUpdate.setEntityToNamespace(this.entity);

            if (this.entityToActionGrid !== "LineItem") {
                const initialDate = Monet.Format.Date.getTodayISOString({ daysOffset: -2 });
                const endDate = Monet.Format.Date.getTodayISOString();
                filterBuilder.setEntity(this.entityToActionGrid);
                filterBuilder.setSelector(this.containerGrid);
                filterBuilder.setCustomNameSpace(this.entity);
                filterBuilder.setIdScreen('RouteSummary');
                filterBuilder.getFieldList();

                if (this.entityToActionGrid === 'RouteView') {
                    defaultFilters = {
                      'route.date_Range': {
                        value: {
                          ini: initialDate,
                          fin: endDate
                        }
                      },
                      primaryDriver: {
                        value: {
                          description: '',
                          id: ''
                        }
                      },
                      'primaryEquipment.key': {
                        value: ''
                      },
                      'route.stops.location.description': {
                        value: ''
                      },
                      'route.status': {
                        value: 'DEPARTED_ORIGIN'
                      },
                      'route.organization': {
                        value: {
                          description: '',
                          id: ''
                        }
                      },
                      'route.key': {
                        value: ''
                      }
                    };

                    // Get the default filters from sessions and Merge with the default filters above

                    // After that, you must delete the session using
                    // delete Monet.Session.RouteSummary.defaultFilters

                    callbackAfterOpenSidebar = function () {
                        App.Views.RouteSummary.sidebarTransition('RouteSummaryRoutes');
                    };

                } else if (this.entityToActionGrid === 'StopView') {

                    if (!App.Forms.RouteSummaryStops.filterFromReports && !App.Forms.RouteSummaryStops.unsuccessfulDelivery) {
                      const route = App.Forms.RouteSummaryStops.route;

                      if (route) {
                        const date = route.get('date');
                        const key = route.get('key');
                        const organization = route.get('organization');
                        const routeSummaryStopsFilters = getStopListFilterPreferences();

                        const initialFilters = {
                          'route.key': {
                            value: key
                          },
                          'route.date': {
                            value: date
                          },
                          'route.organization': {
                            value: { id: organization.id, description: organization.description }
                          }
                        }

                        filterBuilder.clearFiltersToNamespace('RouteSummaryStops');

                        defaultFilters = {...routeSummaryStopsFilters, ...initialFilters}

                        App.Forms.RouteSummaryStops.route = null;
                      } else {
                        defaultFilters = {
                          'route.status': {
                            value: 'DEPARTED_ORIGIN'
                          },
                          'route.date_Range': {
                            value: {
                              ini: initialDate,
                              fin: endDate
                            }
                          },
                        };
                      }
                    } else {
                      filterBuilder.willLoadState = false;
                    }

                    callbackAfterOpenSidebar = function () {
                        App.Views.RouteSummary.sidebarTransition('RouteSummaryStops');
                    };

                } else if (this.entityToActionGrid === 'Order') {

                    const stop = App.Forms.RouteSummaryOrders.stop;
                    if (stop) {

                        const id = stop.get('id');
                        const stopKey = stop.get('key');
                        const order = stop.get('order');
                        filterBuilder.clearFiltersToNamespace('RouteSummaryOrders');
                        if (order && !id && !stopKey) {
                          defaultFilters = {
                            number: {
                              value: order.number
                            }
                          };
                        } else {
                          defaultFilters = {
                            stop: {
                              value: {
                                id,
                                key: stopKey
                              }
                            }
                          };
                        }

                        App.Forms.RouteSummaryOrders.stop = null;

                    } else {
                      defaultFilters = {
                        'routeView.route.date_Range': {
                          value: {
                            ini: initialDate,
                            fin: endDate
                          }
                        },
                        stop: {
                          value: {
                            id: '',
                            description: ''
                          }
                        }
                      };
                    }
                }
                filterBuilder.setCallbackBeforeFilter(this.beforeFilter);
                filterBuilder.setDefaultFilters(defaultFilters);
                filterBuilder.customRequest = executeFilter;

                if (['RouteView', 'StopView', 'Order'].includes(this.entityToActionGrid)) {
                  delete filterBuilder.fieldList['route.driverAssignments.driver'];
                  delete filterBuilder.fieldList['secondaryAssignments.driver'];
                  delete filterBuilder.fieldList['secondaryAssignments.driver.key'];
                  delete filterBuilder.fieldList['routeView.secondaryAssignments.driver'];
                  delete filterBuilder.fieldList['routeView.secondaryAssignments.driver.key'];
                  delete filterBuilder.fieldList['routeView.primaryDriver.name'];
                  delete filterBuilder.fieldList['route.driverAssignments.driver.key'];
                  delete filterBuilder.fieldList['routeView.primaryDriver.key'];
                }

                filterBuilder.setFieldsToDisplayOnFilterBuilder(Object.keys(filterBuilder.fieldList));

                App.Forms[this.entity].filterBuilder = filterBuilder;
                if (!App.Forms[this.entityToActionGrid]) {
                  App.Forms[this.entityToActionGrid] = {};
                }

                App.Forms[this.entityToActionGrid].filterBuilder = filterBuilder;
                filterBuilder.render();
            }

            customizeColumns = new Monet.Grid.ActionsModules.CustomizeColumns();
            exportFormats = new Monet.Grid.ActionsModules.ExportFormats();
            saveGridLayout = new Monet.Grid.ActionsModules.SaveGridLayout();

            element = document.querySelector(this.gridActionsSelector);

            const monetUIGridActions = document.createElement("div");
            monetUIGridActions.setAttribute('class', "MonetUIGridActions");

            if (element) {
              element.innerHTML = '';
              element.appendChild(monetUIGridActions);
              element.appendChild(filterBuilder.el);
            }

            monetUIGridActions.appendChild(new Monet.UI.Help(this.entity, Monet.I18n.getResourcesByKey('RouteMonitor')).render());
            customizeColumns.setEntity(this.entityToActionGrid);
            customizeColumns.setScreenName(this.entity);
            customizeColumns.setSelector(this.gridActionsSelector);
            customizeColumns.setElement(monetUIGridActions);

            customizeColumns.setCallBacks({
                afterSaveList: afterSaveListCallback
            });

            if (['RouteView', 'StopView', 'Order'].includes(this.entityToActionGrid)) {
              customizeColumns.setHiddenFields(fieldsToHideOnTable);
            }

            exportFormats.setEntity(this.entityToActionGrid);
            exportFormats.setScreenName(this.entity);
            exportFormats.setSelector(this.gridActionsSelector);
            exportFormats.setElement(monetUIGridActions);

            if (['LineItem', 'Order'].includes(this.entityToActionGrid)) {
              exportFormats.getDataBeforeExportFormats = () => {
                const data = {
                    filterSort: [],
                    filterCriteriaChain: { criteriaChain: [] },
                    entityToRequest: 'StopView',
                }
                const filterBuilder = App.Objects[this.entity].getFilter();
                if(this.entityToActionGrid === 'LineItem') {
                    if(!filterBuilder.criteriaChain.length){
                        new Greenmile.Components.AlertModal('grid.noOrderSelect')
                            .show();
                        return;
                    }
                    data.entityToRequest = 'LineItem';
                    data.filterSort = filterBuilder.sort;
                    data.filterCriteriaChain = App.Objects[this.entity].getCriteriaForCsvExporter();
                    return data
                  }
                  data.filterSort = filterBuilder.sort;
                  data.filterCriteriaChain = filterBuilder;
                  return data;
              };

            }

            if (this.entityToActionGrid === 'LineItem') {
                exportFormats.retrieveAllColumnsFromEntity = function (callbackLineItem) {
                  const that = this;
                  const request = new DefaultRequest({
                    url: "form/" + that.entity + "/Fields",
                    success: function (data) {
                      callbackLineItem(data, that.entity, that.selector, that.screenName);
                    }
                  });
                  request.send();
                };

                callbackAfterOpenSidebar = function () {
                    App.Views.RouteSummary.sidebarTransition('RouteSummaryOrders');
                    App.Views.RouteSummary.sidebarTransition('RouteSummaryLineItems');
                };

            }

            saveGridLayout.setEntity(this.entityToActionGrid);
            saveGridLayout.setScreenName(this.entity);
            saveGridLayout.setSelector(this.gridActionsSelector);
            saveGridLayout.setElement(monetUIGridActions);

            saveGridLayout.setCallBacks({
                afterSaveList: afterSaveListCallback
            });

            exportFormats.init();
            customizeColumns.init();
            saveGridLayout.init();
            this.exportFormats = exportFormats;

            const autoRefresh = new Monet.Grid.ActionsModules.AutoRefresh();

            if (this.entityToActionGrid !== "LineItem") {
              autoRefresh.setSelector(this.gridActionsSelector);
              autoRefresh.setEntity(this.entity);
              autoRefresh.setScreenName('RouteSummary');
              autoRefresh.init();
              filterBuilder.postRender();
            }

            this.getColumns(function (columnsLoaded) {

              let columns = columnsLoaded || Monet.Grid.getGridLayout(App.Forms[this.entity].layout.index, this.entity);
              indexColumnFrozen = Monet.Grid.getIndexFrozenColumn(App.Forms[this.entity].layout.index);

              if (this.countCustomColumns) {
                  indexColumnFrozen += this.countCustomColumns;
              }

              options.frozenColumn = indexColumnFrozen;

              if (this.addCustomColumns) {

                  columns = this.addCustomColumns(columns);

              }

              enabledMenus = Monet.Grid.Utils.getMenusEnabledFromGridLayout(App.Forms[this.entity].layout.index);

              menu = this.getInstanceOfMenu();

              if (menu) {

                  menu.setEnabledMenus(enabledMenus);

              }

              removeMenu();

              if (this.entityToActionGrid === "Order") {

                  options.selecteRows = true;

              }

              if (['RouteView', 'StopView', 'Order'].includes(this.entityToActionGrid)) {
                columns = columns.filter(item => !fieldsToHideOnTable.includes(item?.fieldInformation?.name));
              }

              dataView = new Monet.Grid.DataProvider(columns, null, this.entity);
              grid = new Monet.Grid.GenericGrid(this.containerGrid, dataView, columns, options);
              Greenmile.RouteSummary.SideBar.grid = grid;
              var updateSideBar = (function (scope) {
                  return function (e, args) {
                      scope.handlerActiveRowSelected(args.row, args.grid);
                      scope.updateSideBar(e, args, scope);
                  };
              }(this));

              grid.onClick.unsubscribe(updateSideBar);
              grid.onClick.subscribe(updateSideBar);

              if (menu) {

                  menu.setOptionsMenu(optionsMenu);

                  var showMenu = function (context) {

                      return function (e, args) {

                          if (!(e.target.className === 'iconNoPicture' ||
                              e.target.className === 'iconWithPicture' ||
                              e.target.className === 'iconNoUnsuccessfulDelivery' ||
                              e.target.className === 'iconUnsuccessfulDelivery' ||
                              e.target.className === 'iconUnSigned' ||
                              e.target.className === 'iconWithSignature' ||
                              e.target.className === 'starsContainer' ||
                              e.target.classList.contains('fa-star'))) {

                              context.showMenuToRowSelected(e, args);
                              e.stopPropagation();

                          }

                      };

                  }(menu);

                  grid.onClick.unsubscribe(showMenu);
                  grid.onClick.subscribe(showMenu);

                  grid.onScroll.unsubscribe(removeMenu);
                  grid.onScroll.subscribe(removeMenu);

              }

              var columnDefault = App.Forms[this.entity].columnToOrders;
              var columnSortDefault = [];

              if (columnDefault) {

                  var sizeColumnDefault = columnDefault.length;

                  for (var i = 0; i < sizeColumnDefault; i++) {

                      var columnToSort = grid.getColumnByFieldName(columnDefault[i].field);
                      var sort = columnDefault[i].order === 'ASC';

                      if (columnToSort) {
                          columnSortDefault.push({ columnId: columnToSort.id, sortAsc: sort });
                      }

                  }

                  if (columnSortDefault.length) {

                      grid.setSortColumns(columnSortDefault);

                  }

              }

              if (this.entityToActionGrid === "Order") {

                  var showLineItemsByClick = function () {

                      var lineSelecteds = this.getSelectedRows();
                      var lineSelectedsSize = lineSelecteds.length;
                      var lineItems = new App.Routers.RouteSummaryLineItems();

                      var ordersId = [];

                      for (var i = 0; i < lineSelectedsSize; i++) {

                          var id = this.getDataItem(lineSelecteds[i]).idOfObject;

                          ordersId.push(id);

                      }

                      App.Forms.RouteSummaryLineItems.ordersIds = ordersId;

                      lineItems.updateGrid(
                          lineItems.getFilter(),
                          Monet.Grid.addDataToGrid,
                          true
                      );

                  };

                  grid.onSelectedRowsChanged.unsubscribe(showLineItemsByClick);
                  grid.onSelectedRowsChanged.subscribe(showLineItemsByClick);

                  App.Forms.RouteSummaryLineItems.ordersIds = null;

              }

              App.Forms[this.entity].table = grid;
              App.Forms[this.entity].dataProvider = dataView;
              App.Forms[this.entity].controlUpdater = controlUpdate;
              App.Forms[this.entity].autoRefresh = autoRefresh;

              Monet.Session.RouteSummary.sidebar.setCallbackAfterHide(callbackAfterOpenSidebar);
              Monet.Session.RouteSummary.sidebar.setCallbackAfterShow(callbackAfterOpenSidebar);

              executeFilter();

              Greenmile.RouteSummary.SideBar.currentEntity = this.entityToActionGrid;
              Greenmile.RouteSummary.SideBar.showRouteStatistics();

              if (this.afterShow) {
                  this.afterShow();
              }
            }.bind(this));

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                'Error on show grid on route monitoring.', e);
            error.console();

        }

    };

    this.updateSideBar = function (e, args, scope) {
        var row            = args.row,
            selectedItem   = args.grid.getDataItem(row),
            selectedOption = scope.selectedOption();

        switch (selectedOption) {
            case 'route':
                Greenmile.RouteSummary.SideBar.getRouteInformation(selectedItem);
                break;
            case 'stop':
                Greenmile.RouteSummary.SideBar.getStopInformation(selectedItem);
                break;
            case 'item':
                break;
            default:
                break;
        }
    };

    this.selectedOption = function () {
        var options = document.getElementsByName('gridSelector');
        var max      = options.length,
            selected = 0;

        for (var i = 0; i < max; i++) {
            if (options[i].checked) {
                selected = i;
            }
        }

        return this.selectedOptionToString(selected);
    };

    this.selectedOptionToString = function (selectedIndex) {
        switch (selectedIndex) {
            case 0:
                return 'route';
            case 1:
                return 'stop';
            default:
                return 'item';
        }
    };

    this.handlerActiveRowSelected = function(row, grid) {
        const keyOfGridControl = "row_highlight";
        const cols = grid.getColumns();
        let colsInRowToSelect = {}
        for(let i = 0; i < cols.length; i++) {
            colsInRowToSelect[cols[i].id] = "selected-row";
        }

        grid.removeCellCssStyles(keyOfGridControl);
        grid.addCellCssStyles(keyOfGridControl, { [row] : colsInRowToSelect });
    }
};

